import { type SavedDatesRuralityCookie } from '../entities/SavedDatesRuralityCookie'

export const useSavedDatesRuralityCookie = () => {
  const { getCookieRurality, setCookieRurality } = useCookiesRurality()

  const cookieName = 'rentUnitSavedDates'

  function getSavedDates(): SavedDatesRuralityCookie {
    const cookieInstance: any = getCookieRurality(cookieName)

    const item: SavedDatesRuralityCookie = {
      dateIn: cookieInstance?.dateIn || '',
      dateOut: cookieInstance?.dateOut || '',
      capacity: cookieInstance?.capacity || '',
    }

    return item
  }

  function setSavedDates(
    cottageContactPageRepository: SavedDatesRuralityCookie,
  ) {
    const days = 1
    setCookieRurality(cottageContactPageRepository, cookieName, days)
  }

  return {
    getSavedDates,
    setSavedDates,
  }
}
